
import whats_img from "../../../../../../resources/subscription/whatsapp_logo.png";
import inst_img from "../../../../../../resources/instagram_logo.png";
import face_img from "../../../../../../resources/subscription/facebook_logo.png";
import ExampleSocialCard from "./ExampleSocialCard";

export default function ExampleSocial() {
    return (
        <div className="exampleSocialDiv">
            <ExampleSocialCard img={face_img} size={"85%"}/>
            <ExampleSocialCard img={inst_img} size={"80%"}/>
            <ExampleSocialCard img={whats_img} size={"110%"}/>
        </div>
    )
}
